// src/features/interview/components/InterviewCompleteScreen.jsx
import React from "react";
import { CheckCircle, Sparkles, Star } from "lucide-react";

const InterviewCompleteScreen = ({ createConfetti }) => {
  const confetti = createConfetti();

  return (
    <div className="relative w-full flex items-center justify-center rounded-lg overflow-hidden">
      {/* Confetti elements (rendered as divs with inline style classes to match original) */}
      {confetti.map((c) => (
        <div
          key={c.key}
          className={`absolute w-2 h-2 rounded-full ${c.colorClass} animate-confetti`}
          style={c.style}
        />
      ))}
      <div className="text-center space-y-6 p-8 animate-fade-in">
        <div className="inline-flex items-center justify-center">
          <div className="relative">
            <CheckCircle className="w-20 h-20 text-green-500 animate-bounce" />
            <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-20" />
          </div>
        </div>
        <Sparkles className="absolute top-10 left-10 w-6 h-6 text-yellow-400 animate-spin-slow" />
        <Star className="absolute bottom-10 right-10 w-6 h-6 text-purple-500 animate-pulse" />
        <div className="relative z-10 space-y-4">
          <h2 className="text-3xl font-bold text-slate-400 animate-slide-up">
            Interview Complete!
          </h2>
          <p className="text-lg text-slate-500 max-w-md mx-auto animate-fade-in-delay">
            Thank you for participating in the interview process.
          </p>
          {/* <button
            className="mt-6 px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white rounded-full font-semibold
                  shadow-lg transform transition-all duration-300 hover:scale-105 hover:shadow-xl
                  animate-fade-in-delay-2 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
          >
            Return Home
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default InterviewCompleteScreen;
